import React from 'react';
import {} from '@ant-design/icons';
import AndroidIcon from '@/assets/images/public/icon-android.react.svg?react';
import AppTv from '@/assets/images/public/icon-apple-tv.react.svg?react';
import ElectronIcon from '@/assets/images/public/icon-electron.react.svg?react';
import FlutterIcon from '@/assets/images/public/icon-flutter.react.svg?react';
import HarmonyIcon from '@/assets/images/public/icon-harmony.react.svg?react';
import HippyIcon from '@/assets/images/public/icon-hippy.react.svg?react';
import IosIcon from '@/assets/images/public/icon-ios.react.svg?react';
import KuiklyIcon from '@/assets/images/public/icon-kuikly.react.svg?react';
import LinuxIcon from '@/assets/images/public/icon-linux.react.svg?react';
import MacIcon from '@/assets/images/public/icon-mac.react.svg?react';
import MiniprogramIcon from '@/assets/images/public/icon-mini-program.react.svg?react';
import VisionOSIcon from '@/assets/images/public/icon-VisionOS.react.svg?react';
import WindowsIcon from '@/assets/images/public/icon-windows.react.svg?react';
import ReactNativeIcon from '@/assets/images/public/react-native.svg?react';

export const getAppIcon = (pid?: string) => {
  switch (pid) {
    case `${Platform.Flutter}`:
      return <FlutterIcon />;
    case `${Platform.Android}`:
      return <AndroidIcon />;
    case `${Platform.IOS}`:
      return <IosIcon />;
    case `${Platform.Mac}`:
      return <MacIcon />;
    case `${Platform.Windows}`:
      return <WindowsIcon />;
    case `${Platform.HarmonyOS}`:
      return <HarmonyIcon/>;
    case `${Platform.Hippy}`:
      return <HippyIcon style={{ width: 16, height: 16 }} />;
    case `${Platform.VisionOS}`:
      return <VisionOSIcon />;
    case `${Platform.Kuikly}`:
      return <KuiklyIcon style={{ width: 16, height: 16 }} />;
    case `${Platform.MiniProgram}`:
      return <MiniprogramIcon />;
    case `${Platform.Electron}`:
      return <ElectronIcon />;
    case `${Platform.ReactNative}`:
      return <ReactNativeIcon />;
    case `${Platform.Linux}`:
      return <LinuxIcon />;
    case `${Platform.AppleTV}`:
      return <AppTv />;
    case `${Platform.ReactNative}`:
      return <ReactNativeIcon/>;
    default:
      return undefined;
  }
};

export enum CapitalPlatform {
  Android = 'Android',
  IOS = 'IOS',
  Mac = 'Mac',
  Windows = 'Windows',
  Flutter = 'Flutter',
  HarmonyOS = 'Harmony',
  Hippy = 'Hippy',
  VisionOS = 'VisionOS',
  Kuikly = 'Kuikly',
  MiniProgram = 'MiniProgram',
  Electron = 'Electron',
  AppleTV = 'AppleTV',
  ReactNative = 'ReactNative',
  Linux = 'Linux'
}

export enum Platform {
  Android = 1,
  IOS = 2,
  Mac = 4,
  Linux = 5,
  Flutter = 9,
  Windows = 10,
  HarmonyOS = 11,
  Hippy = 14,
  Kuikly = 15,
  VisionOS = 17,
  // 预定义，后台可能会改
  MiniProgram = 18,
  Electron = 19,
  AppleTV = 20,
  ReactNative = 21
}

export enum AccessPlatformType {
  App = 1,
  SDK = 2,
  Extension = 3,
  Multi = 4,
  Hippy = 14,
  Kuikly = 14,
  // 预定义，后台可能会改
  MiniProgram = 18,
  Electron = 19,
  ReactNative = 21
}

const style: React.CSSProperties = {
  marginLeft: 10,
  verticalAlign: 'text-bottom',
};

export const getAppName = (pid?: number | null, isFlutter?: boolean | number | null) => {
  if (!!isFlutter) return <span><FlutterIcon /><span style={style}>Flutter</span></span>;
  switch (pid) {
    case Platform.Android:
      return <span><AndroidIcon /><span style={style}>Android</span></span>;
    case Platform.IOS:
      return <span><IosIcon /><span style={style}>IOS</span></span>;
    case Platform.Mac:
      return <span><MacIcon /><span style={style}>Mac</span></span>;
    case Platform.Windows:
      return <span><WindowsIcon /><span style={style}>Windows</span></span>;
    case Platform.HarmonyOS:
      return <span><HarmonyIcon /><span style={style}>Harmony</span></span>;
    case Platform.MiniProgram:
      return <span><MiniprogramIcon /><span style={style}>小程序</span></span>;
    default:
      return undefined;
  }
};

export const getPlatformName = (platformId?: number) => {
  const platformMap: Record<number, string> = {
    [Platform.Android]: 'Android',
    [Platform.IOS]: 'iOS',
    [Platform.Mac]: 'Mac',
    [Platform.Windows]: 'Windows',
    [Platform.Flutter]: 'Flutter',
    [Platform.HarmonyOS]: 'Harmony',
    [Platform.Hippy]: 'Hippy',
    [Platform.VisionOS]: 'VisionOS',
    [Platform.Kuikly]: 'Kuikly',
    [Platform.MiniProgram]: '小程序',
    [Platform.Electron]: 'Electron',
    [Platform.Linux]: 'Linux',
    [Platform.AppleTV]: 'AppleTV',
    [Platform.ReactNative]: 'ReactNative',
  };
  return platformMap[platformId || -1] || '未知';
};
